import $ from 'jquery'

$('#hamburger-icon').on('click', toggleMenu)
$('#page-wrap').on('click', closeMenu);

let state = {
    menuOpen: false
}

function toggleMenu () {
    state.menuOpen = !state.menuOpen
}

function openMenu () {
    state.menuOpen = true
}

function closeMenu () {
    state.menuOpen = false
}

// Reacts to the state when it changes..
/*
WatchJS.watch(state, 'menuOpen', () => {
    $('body').toggleClass('mobile-menu-open', state.menuOpen);
    $('#hamburger-icon .hamburger').toggleClass('is-active', state.menuOpen);
})
*/


// WEBPACK FOOTER //
// ./src/js/app/mobile-menu.js